import script from "./BondPageHero.vue?vue&type=script&lang=ts&setup=true"
export * from "./BondPageHero.vue?vue&type=script&lang=ts&setup=true"

import "./BondPageHero.vue?vue&type=style&index=0&id=797792be&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-797792be"]])

export default __exports__